import * as React from 'react';
import * as style from './style.css';
import { SkeletonHeader } from './SkeletonHeader';
import { SkeletonRow } from './SkeletonRow';
import { SkeletonTableHead } from './SkeletonTableHead';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Skeleton = () => {
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsx(SkeletonHeader, {}), /*#__PURE__*/_jsxs("div", {
      className: style['table'],
      children: [/*#__PURE__*/_jsx(SkeletonTableHead, {}), /*#__PURE__*/_jsx(SkeletonRow, {}), /*#__PURE__*/_jsx(SkeletonRow, {}), /*#__PURE__*/_jsx(SkeletonRow, {}), /*#__PURE__*/_jsx(SkeletonRow, {})]
    })]
  });
};